export var getInitials = function (str, num) {
    if (num === void 0) { num = 2; }
    var initialsArr = str
        .toUpperCase()
        .split(" ")
        .map(function (n) { return n[0]; });
    if (num === 2) {
        return "".concat(initialsArr.shift() || "").concat(initialsArr.pop() || "");
    }
    return initialsArr.join("").slice(0, num);
};
